import Model from './Model'

export default class Webhook extends Model {
  id: number
  url: string
  firstFinished: boolean
  secondFinished: boolean
  init: boolean
  update: boolean
  secretKey: string
  createdAt: string

  constructor(json) {
    super({})
    this.id = json.id
    this.url = json.url
    this.firstFinished = json.firstFinished
    this.secondFinished = json.secondFinished
    this.init = json.init
    this.update = json.update
    this.secretKey = json.secretKey
    this.createdAt = json.createdAt
  }
}
